import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=6994ed71&scoped=true&"
import script from "./addGroup.vue?vue&type=script&lang=js&"
export * from "./addGroup.vue?vue&type=script&lang=js&"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=6994ed71&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994ed71",
  null
  
)

export default component.exports